module.exports = __webpack_public_path__ + "img/select.ef9fbacd.svg";